import clsx from 'clsx';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import { FadeOnScroll } from '@/components/Animations';
import { Navigation } from '@/components/Navigation';

import { AnimatedChainDivider } from '../ChainDivider';
import { Logo } from '../Logo';
import { SocialShare } from '../SocialShare';

import { PageTopButton } from './PageTopButton';

export type FooterProps = {
  className?: string;
};

export const Footer = ({ className }: FooterProps) => {
  // const isAprilFools = new Date().getMonth() === 3 && new Date().getDate() === 1;
  return (
    <div className={clsx('relative h-[500px]', className)}>
      <div className="absolute w-full h-full bg-gradient-to-b from-transparent to-primary opacity-40 z-0" />
      <FadeOnScroll height="500px">
        <div className="h-full flex flex-col items-center justify-evenly text-center pt-20">
          <div className="z-20">
            <Logo type="02" className="h-20" />
          </div>
          <div className="z-20">
            <SocialShare />
          </div>
          <Navigation className="flex flex-wrap justify-center text-sm max-w-[80%]" />
          <div className="z-20">
            <div className="text-sm">©︎きただりょうま/監禁JK制作委員会</div>
            <p className={'text-xs opacity-50 m-2'}>2022年エイプリルフール企画</p>
          </div>
        </div>
        <PageTopButton className="absolute top-8 right-0 mr-[5%]" />
      </FadeOnScroll>
      <LazyLoadComponent>
        <AnimatedChainDivider divClassName="absolute right-0 bottom-0" />
      </LazyLoadComponent>
    </div>
  );
};
